import { MDBCheckbox, MDBInput } from 'mdb-react-ui-kit';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import registration from '../../Assets/Images/Car.jpg';
import { DatePicker, Select } from 'antd';
import moment from 'moment';
import apiUrls from '../../Api/MainApi';
import axios from 'axios';
import Loader from '../../Layout/Loader/Loader';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { convertDate } from '../../Utils/utils';

function RegistrationInfo({
    setFormData,
    formData,
    isNextDisabled,
    vehicleError,
    setPage,
    proceed
}) {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);
    const [rtoDropdown, setRtoDropDown] = useState([])
    const [errors, setErrors] = useState({
        registrationNumber: '',
        registrationLocation: '',
        registrationDate: ''
    });
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        // Convert the input value to uppercase if the name is 'registrationNumber'
        const uppercaseValue = name === 'registrationNumber' ? value.toUpperCase() : value;
        setFormData(prevData => ({
            ...prevData,
            [name]: uppercaseValue
        }));
    };
    const handleDateChange = (date, dateString) => {
        setFormData(prevData => ({
            ...prevData,
            registrationDate: dateString ? moment(dateString).format('YYYY-MM-DD') : ''
        }));
        setErrors(prevErrors => ({
            ...prevErrors,
            registrationDate: dateString ? '' : 'Registration date is required'
        }));
    };

    useEffect(() => { // this useEffect is to get data for Rto 
        const fetchData = async () => {
            const RtoResponse = await axios.get(apiUrls.GetRtoDropDown);
            const datas = await RtoResponse.data.data
            setRtoDropDown(datas);
            console.log(datas, "line 47")
        }
        fetchData();
    }, [])
    const handleRtoChange = (selectedOption) => { // to store and manipulate the data from the make dropdown
        setFormData(prev => ({
            ...prev,
            registrationLocation: selectedOption
        }))
    }
    const handleVahaanApi = async () => {

        setLoading(true); // Set loading to true before the API call
        try {
            const vahaanApi = await axios.post(apiUrls.GetVehicleDetails, { Consent: "Y", RegistrationNo: formData.registrationNumber, VehicleCategory: "Motor", VehicleType: "Car" });
            const vahaanData = vahaanApi.data.data;
            if (vahaanData.vehicleCategory) {
                console.log(vahaanData, "line 60");
                // const manufacturingYear = vahaanData.manufacturingYear;
                // const year = manufacturingYear.split('/')[1];
                const expiryDate = convertDate(vahaanData.expiryDate)   //  manual function to convert date reference above in import statements
                const registrationDate = convertDate(vahaanData.registrationDate) // manual function to convert the registration date
                console.log(expiryDate, "line 75 ")
                const rtoCode = vahaanData.rtocode.replace('-', '');
                setFormData(prev => ({
                    ...prev,
                    makeSearch: vahaanData.make,
                    modelSearch: vahaanData.model,
                    variantSearch: vahaanData.model,
                    fuel: vahaanData.fuelType,
                    registrationLocation: rtoCode,
                    previousPolicyExpiryDate: expiryDate,
                    registrationDate: registrationDate,
                    name: vahaanData.customerName
                }));
                setPage((currPage) => currPage + 1);
            }
            else if (vahaanData.vehicleCategory === "Bike") {   // trigger sweetAlert to navigate to bike section
                Swal.fire({
                    title: "You have entered bike details",
                    text: "Do you wish to continue with bike insurance?",
                    icon: "question",
                    showDenyButton: true,
                    denyButtonText: "Cancel",
                    confirmButtonText: "Okay"
                }).then((result) => {
                    if (result.isConfirmed) {
                        // User clicked "Okay"
                        // You can add your logic here for the confirmed action
                        navigate(`${process.env.PUBLIC_URL}/motor-insurance`)
                    } else if (result.isDenied) {
                        // User clicked "Cancel"
                        navigate(`${process.env.PUBLIC_URL}/`); // Redirect to the desired URL
                    }
                });
            } else {
                console.log(vahaanData, "line 106")
                Swal.fire({
                    title: "Invalid Vehicle Details",
                    text: "Please enter valid vehicle details",
                    icon: "error",
                });
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false); // Set loading to false after the API call
        }
    }
    const filterOption = (input, option) =>   //  to filter for antd
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    return (
        <>
        {loading && <Loader />} {/* Display the loader component when loading is true */}
        {!loading && (
            <div className='container mt-5 mb-5'>
                <div className=''>

                    <div className=' mt-4'>
                        <form>
                            {
                                formData.registrationInfo === 2 && (
                                    <>
                                        <div className='d-flex justify-content-between gap-5'>
                                            <MDBInput
                                                label='Registration Number'
                                                className='registration-number-input'
                                                name='registrationNumber'
                                                value={formData.registrationNumber}
                                                onChange={handleInputChange}
                                                id='formControlLg'
                                                type='text'
                                                size='lg'
                                            />
                                            <button
                                                className='btn btn-success'
                                                type='button'
                                                onClick={handleVahaanApi}
                                                style={{ whiteSpace: 'nowrap' }}
                                                disabled={proceed}
                                            >
                                                Proceed
                                            </button>
                                        </div>
                                        {formData.registrationNumber && proceed && (
                                            <div className='text-danger'>{vehicleError}</div>
                                        )}
                                    </>
                                )}
                            {/* {formData.registrationInfo === 2 && (
                                <>
                                    <div className='registration-location d-flex gap-4'>
                                        <span className='mt-1'>Enter registration location</span>
                                        <Select
                                            name="Rto"
                                            showSearch
                                            filterOption={filterOption}
                                            value={formData.registrationLocation}
                                            onChange={handleRtoChange}
                                            options={(rtoDropdown || [
                                                {
                                                    id: 0,
                                                    name: "No Rto Found",
                                                }
                                            ]).map((make) => ({ value: make.id, label: make.name }))}
                                            className="width-specifiying"
                                            placeholder="Select Rto location"
                                        />
                                    </div>
                                    {errors.registrationLocation && <div className="text-danger">{errors.registrationLocation}</div>}
                                    <div className='registration-date d-flex gap-5 mt-5'>
                                        <span className='mt-1'>Enter registration date</span>
                                        <DatePicker
                                            className='width-date'
                                            onChange={handleDateChange}
                                        />
                                    </div>
                                    {errors.registrationDate && <div className="text-danger">{errors.registrationDate}</div>}
                                </>
                            )} */}
                            {formData.registrationInfo === 1 && (
                                <>
                                    <div className='registration-location d-flex gap-4'>
                                        <span className='mt-1'>Enter registration location</span>
                                        <Select
                                            name="Rto"
                                            showSearch
                                            filterOption={filterOption}
                                            value={formData.registrationLocation}
                                            onChange={handleRtoChange}
                                            options={(rtoDropdown || [
                                                {
                                                    id: 0,
                                                    name: "No Rto Found",
                                                }
                                            ]).map((make) => ({ value: make.id, label: make.name }))}
                                            className="width-specifiying"
                                            placeholder="Select Rto location"
                                        />
                                    </div>
                                    {errors.registrationLocation && <div className="text-danger">{errors.registrationLocation}</div>}
                                </>
                            )}
                            {/* Other code remains the same */}
                            <div className='options-resgistration mt-5 d-flex justify-content-between'>
                                <MDBCheckbox
                                    name='flexCheck'
                                    value=''
                                    id='flexCheckDefault1'
                                    label="Enter Registration number "
                                    checked={formData.registrationInfo === 2}
                                    onChange={() => {
                                        setFormData(prevData => ({
                                            ...prevData,
                                            registrationInfo: prevData.registrationInfo === 2 ? 1 : 2
                                        }));
                                    }}
                                />
                                <MDBCheckbox
                                    name='flexCheck'
                                    value=''
                                    id='flexCheckDefault2'
                                    label='Is it a new vehicle ?'
                                    checked={formData.registrationInfo === 1}
                                    onChange={() => {
                                        setFormData(prevData => ({
                                            ...prevData,
                                            registrationInfo: prevData.registrationInfo === 1 ? 2 : 1
                                        }));
                                    }}
                                />
                            </div>
                        </form>
                    </div>

                </div>
            </div>
             )}
        </>
    );
}

export default RegistrationInfo;
